import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-wrapper',
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    standalone: false
})
export class WrapperComponent {
  public constructor(private mUserService: UserService, private mRouter: Router, public messageService: MessageService) {
  }

  public isActive(root: string) {
    return window.location.pathname.toLowerCase().startsWith(`/${root}`);
  }

  public signOut() {
    this.mUserService.signOut();
    this.mRouter.navigate(['/login']);
  }
}
